module.exports = __webpack_public_path__ + "img/Gerd_Janson.13a6fc2f.jpg";